<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#00A3B3" type="ball-atom" [fullScreen]="true" [template]="template">
</ngx-spinner>
